import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

export const TEMPLATE_VARIABLES = [
  { key: 'candidateName', labelKey: 'communications.variables.candidateName' },
  { key: 'jobTitle', labelKey: 'communications.variables.jobTitle' },
  { key: 'companyName', labelKey: 'communications.variables.companyName' },
  { key: 'interviewLink', labelKey: 'communications.variables.interviewLink' }
] as const;

export type TemplateVariableKey = (typeof TEMPLATE_VARIABLES)[number]['key'];

interface Props {
  onInsert: (variable: string) => void;
  disabled?: boolean;
}

export function TemplateVariableButtons({ onInsert, disabled }: Props): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2">
      {TEMPLATE_VARIABLES.map(({ key, labelKey }) => (
        <Button
          key={key}
          type="button"
          variant="outline"
          size="xs"
          disabled={disabled}
          onClick={() => {
            onInsert(`{{${key}}}`);
          }}
        >
          <Plus className="size-3" />
          {t(labelKey)}
        </Button>
      ))}
    </div>
  );
}

/**
 * Replace {{variable}} placeholders with example preview values.
 */
export function renderPreview(template: string): string {
  const examples: Partial<Record<TemplateVariableKey, string>> = {
    candidateName: 'John Doe',
    jobTitle: 'Warehouse Associate',
    companyName: 'Acme Corp',
    interviewLink: 'https://app.example.com/invite/abc123'
  };
  return template.replace(/\{\{(\w+)\}\}/g, (_match, key: string) => {
    return examples[key as TemplateVariableKey] ?? `{{${key}}}`;
  });
}
